<template lang="pug">
.card-content(@click="$emit('click')")
  el-card.card-totais(shadow="always" class="box-card")
    h3 {{ labelCard }}
    p Quantidade de processos no setor: {{ setorWithCount.qtdProcessos }}
</template>

<script>
const { setoresSemSigla } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  props: {
    setorWithCount: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelCard () {
      if (setoresSemSigla.includes(this.setorWithCount.setor.codigo)) {
        return `${this.setorWithCount.setor.nome}`
      }
      return `${this.setorWithCount.setor.codigo.replace(/_/g, ' ')} - ${this.setorWithCount.setor.nome}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-totais {
    cursor: pointer;
    height: 150px;
    background-color: #ffffff;
    color: white !important;
    border: 2px solid #1abc9c;
    margin: 20px 20px 0 20px;
    border-radius: 12px;
    padding: 0 10px;

    &:hover {
      background-color: #1abc9c0a;
    }
  }

  .card-content {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/screens/produtividade/components/CardSetorProdutividade.vue